

export const wanFAQ = {
    title: 'Wan 2.5 常见问题（原生音频视频生成）',
    sub: '完整介绍 Wan 2.5 的音视频生成能力、定价、内容政策，以及与其他 AI 视频模型的比较。',
    items: [
      { num: '01', q: '什么是 Wan 2.5？原生音频有何独特之处？', a: 'Wan 2.5 是阿里巴巴的 AI 视频生成模型，具行业首创的原生音频能力。不同于只生成无声视频的工具，Wan 2.5 可在生成画面的同时产生同步对白、背景音乐、音效与唇形对齐。' },
      { num: '02', q: 'Wan 2.5 与其他 AI 视频模型相比如何？', a: '优势包括原生音频生成、10 秒时长、友好的积分定价、较宽松的内容政策与强大的多语言支持。视觉质量具竞争力，并以独特音频能力脱颖而出。' },
      { num: '03', q: '视频时长、分辨率与比例有哪些选项？', a: '时长：5 秒或 10 秒。分辨率：720p 或 1080p。比例：16:9、9:16、1:1。文字转视频支持所有比例；图片转视频沿用原图比例。皆包含原生音频。' },
      { num: '04', q: 'Wan 2.5 费用如何计算？', a: '采用积分制按次计费。示例：5 秒 720p = 60 分、5 秒 1080p = 100 分；10 秒 720p = 120 分、10 秒 1080p = 200 分。价格皆含原生音频。' },
      { num: '05', q: '能生成哪些内容？是否有内容限制？', a: '在遵循法规前提下，Wan 2.5 以较宽松的审核政策支持大胆、动态的创作。适合社交媒体、广告营销、艺术创作与商业用途。' },
      { num: '06', q: '视频可以商用吗？版权如何？', a: '可以。所有生成的视频与音频皆可商用，你拥有输出内容的权利。原生音频也减少背景音乐与音效的版权顾虑。' },
      { num: '07', q: '如何让原生音频效果更好？', a: '在提示词中描述期望的音频（如“史诗电影配乐”“森林环境声”），并指定运镜与画面节奏。可使用反向提示排除不需要的音频元素。' },
      { num: '08', q: '是否支持多种语言？', a: '是。具备优秀的多语言支持（含中文），可正确发音并与唇形对齐。' }
    ],
    cta: '还有关于 Wan 2.5 的问题？',
    contact: '联系支持团队'
  };
